module.exports = __webpack_public_path__ + "img/shipin.e254503a.jpg";